var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.9941H3.5C3.08579 16.9941 2.75 16.6584 2.75 16.2441V2.74414C2.75 2.32993 3.08579 1.99414 3.5 1.99414H15.5C15.9142 1.99414 16.25 2.32993 16.25 2.74414V16.2441C16.25 16.6584 15.9142 16.9941 15.5 16.9941ZM5.75 4.99414V7.99414H8.75V4.99414H5.75ZM5.75 9.49414V10.9941H13.25V9.49414H5.75ZM5.75 12.4941V13.9941H13.25V12.4941H5.75ZM10.25 5.74414V7.24414H13.25V5.74414H10.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.02814f851bc70299d9bd80f2fcdd144b.svg";
export { ForwardRef as ReactComponent };